import * as REASON from "store/constants/support";

export const structureMailData = (
  values,
  language,
  recipients,
  emailLabel,
  location
) => {
  const name = `${values.title}. ${values.fullname}`;
  const phone = `+${values.code} ${values.phone}`;
  const email = values.email;
  const contact = values.contact.join(", ");
  const promotional = values?.promotional
    ? "I would like to receive AYANA’s newsletters and promotional information."
    : "";

  const emailRecipient = recipients.find(
    (rcp) => rcp.language === language
  ).email;
  let supportInfo = {
    recipient: emailRecipient,
    subject: emailLabel,
    inquiry: values?.inquiry,
    wechat: values?.wechat,
    name,
    phone,
    email,
    contact_me: contact,
    promotional,
    property: location,
  };

  switch (values.reason) {
    case REASON.STAY_VOUCHER_INQUIRY:
      return {
        ...supportInfo,
        hotel_voucher: values.hotelVoucher.join(", "),
      };

    case REASON.CRUISE_INQUIRY:
      return {
        ...supportInfo,
        preferred_sailing_month: values.sailingMonth,
        preferred_room: values.preferredRoom,
      };
    case REASON.DAILY_BOAT_TRIP_INQUIRY:
      return {
        ...supportInfo,
        activity: values.activity,
      };
    case REASON.MEETINGS_INQUIRY:
      const country =
        values.countryOption === "indonesia" ? "Indonesia" : values.country;
      return {
        ...supportInfo,
        destination: values.destination,
        event_name: values.eventName,
        event_type: values.eventType,
        guest_count: values.guestCount,
        desired_from_date: values.fromDesireDate,
        desired_until_date: values.untilDesireDate,
        alternative_from_date: values.fromAlternativeDate,
        alternative_until_date: values.untilAlternativeDate,
        event_requirement: values.eventRequirement,
        accommodation_requirement: values.accommodationRequirement,
        company_name: values.companyName,
        company_address: values.companyAddress,
        city: values.city,
        country: country,
      };

    case REASON.WEDDING_INQUIRY:
      return {
        ...supportInfo,
        destination: values.destination,
        wedding_plan: values.weddingPlan,
        wedding_schedule: values.scheduleOptions,
        desired_date:
          values.weddingDateOption === "knownDate"
            ? values.desireDate
            : "Do not have date yet",
        alternative_date:
          values.weddingDateOption === "knownDate"
            ? values.alternativeDate
            : "Do not have date yet",
        guest_count: values.guestCount,
        additional_note: values.additionalNote,
        nationality: values.nationality,
        brochure_preference: values.brochurePreferenceOption,
        postal_code: values.postalCode,
        prefecture: values.prefecture,
        address: `${values.address}, ${values.city}`,
        address_detail: values.addressDetail,
        hiragana_name: values.hiraganaName,
      };

    case REASON.BOAT_CHARTER:
      return {
        ...supportInfo,
        boat: values.boat,
        purpose: values.purpose,
        preferred_sailing_month: values.sailingMonth,
      };

    case REASON.DINING_INQUIRY:
      return {
        ...supportInfo,
        restaurant: values.restaurant,
        request_date: `${values.requestDate} ${values.requestHour}:${values.requestMinute}`,
        hotel_voucher: values.hotel,
        room_number: values.hotel !== "Other" && values.roomNumber,
        adults: values.adults,
        children: values.children || 0,
      };
    case REASON.SPA_INQUIRY:
      return {
        ...supportInfo,
        spa: values.spa,
        spa_treatment: values.spaTreatment,
        request_date: `${values.requestDate} ${values.requestHour}:${values.requestMinute}`,
        hotel_voucher: values.hotel,
        room_number: values.hotel !== "Other" && values.roomNumber,
        checkin_date: values.checkinDate,
        guest_count: values.guests,
      };

    case REASON.EXPERIENCE_INQUIRY:
      return {
        ...supportInfo,
        experience: values.experience,
        request_date: values.requestDate,
        hotel_voucher: values.hotelOptions,
        checkin_date: values.checkInDate,
        adults: values.adults,
        children: values.children,
        room_number: values[`roomNumber_${values.hotelOptions}`],
      };

    default:
      return {
        ...supportInfo,
        general_inquiry_subject: values.subject,
      };
  }
};

export const structureJakartaMailData = (values, recipient) => {
  return {
    subject: "General Inquiry",
    general_inquiry_subject: values.subject,
    recipient: recipient.emails[0].email,
    inquiry: values.inquiry,
    property: "JAKARTA",
    name: `${values.title}. ${values.fullname}`,
    phone: `+${values.code} ${values.phone}`,
    email: values.email,
    contact_me: values.contact.join(", "),
  };
};
